import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import { Menu, MenuItem, Fade } from '@mui/material';
import moment from 'moment';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';

import CustomTableV2 from '../../common/CustomTableV2';
import CustomSliderModalV2 from '../../common/CustomSliderModalV2';
import AddUser from './components/AddUser';

import { GetUsers } from "../../redux/user/actions";
import { GetMyProfile } from "../../redux/profile/actions";


import "./style.css";


function Therapist(props) {
    const { company, token, name, adminID } = JSON.parse(localStorage.getItem("admin-info"));
    const [data, setData] = useState([])

    // MENU STATES
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentIndex, setCurrentIndex] = useState('');
    const open = Boolean(anchorEl);
    const handleClick = (event, index) => {
        setCurrentIndex(index)
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    // SLIDER STATES
    const [user, setUser] = useState('')
    const [showModal, setShowModal] = useState(false)
    const [showType, setShowType] = useState(false)

    const sliderTitles = {
        add: "ADD USER",
        edit: "EDIT USER",
        qr: "ONBOARDING LINK",
    }

    return (
        <div className="main-container">
            <Fade in>
                <div>
                    <CustomTableV2
                        title="Therapists"
                        description="Control permission of users."
                        store={props.User}
                        table={{
                            headers: [
                                { title: "#" },
                                { title: "Last Name", value: "last_name", },
                                { title: "First Name", value: "first_name", },
                                { title: "Email Address", value: "email_address", },
                                { title: "Company", value: "company", },
                                { title: "" },
                            ],
                            body: (user, i) => {
                                return (
                                    <tr className={i % 2 == 0 ? "tr-even" : ""}>
                                        <td><h5>{i}</h5></td>
                                        <td><h5>{user.last_name?.toUpperCase()}</h5></td>
                                        <td><h5>{user.first_name?.toUpperCase()}</h5></td>
                                        <td><h5>{user.email_address}</h5></td>
                                        <td><h5>{user.name?.toUpperCase()}</h5></td>
                                        <td>
                                            <h5>
                                                <MoreHorizIcon
                                                    id="basic-button"
                                                    onClick={(e) => handleClick(e, i)}
                                                    sx={{ fontSize: 40, cursor: 'pointer' }}
                                                />
                                                {i === currentIndex && (
                                                    <Menu
                                                        sx={{ zIndex: 800 }}
                                                        id="basic-menu"
                                                        anchorEl={anchorEl}
                                                        open={open}
                                                        onClose={handleClose}
                                                        MenuListProps={{
                                                            'aria-labelledby': 'basic-button',
                                                        }}
                                                    >
                                                    </Menu>
                                                )}
                                            </h5>
                                        </td>
                                    </tr>
                                )
                            }
                        }}
                        actions={{
                            add: () => {
                                setShowModal(true);
                                setShowType("add");
                            },
                            qr: name && token ? () => {
                                setShowModal(true);
                                setShowType("qr");
                            } : null,
                            get: (page, count, filter, sort) => {
                                props.GetUsers(page, count, { ...filter, therapist_id: '!null' }, sort);
                            }
                        }}
                    />
                </div>
            </Fade>

            <CustomSliderModalV2 show={showModal} setShow={setShowModal} title={"ACTIVATE THERAPIST"}>
                {
                    showType == "add" && <AddUser setShowModal={setShowModal} reload={() => {
                        props.GetUsers(1, 10, { therapist_id: '!null' });
                    }} />
                }
            </CustomSliderModalV2>
        </div>

    );
}

const mapStateToProps = (state) => ({
    User: state.User
})

export default connect(mapStateToProps, {
    GetUsers,
    GetMyProfile,
})(Therapist);
